import { render, staticRenderFns } from "./tab-approved.vue?vue&type=template&id=47ca7cd1"
import script from "./tab-approved.vue?vue&type=script&lang=js"
export * from "./tab-approved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports